/* ============
 * Amenities Page
 * ============
 *
 * todo: add documentation here!
 */
import {ChevronRight, ZoomIn, X} from 'vue-feather-icon'
import layout from '@/layouts/page/page.vue'
import divider from '@/components/general/divider.vue'

import {mapState} from 'vuex'

export default {
  mounted() {
    let for_loop = 0;
    this.loading = true;
    if (this.hotel === false) {
      this.$store.dispatch('setPropDetails');
    }
    this.params = this.$route.params;
    if (this.params.hasOwnProperty('images')) {
      document.getElementsByTagName('title')[0].innerHTML = this.params.name + ' | ' + this.hotel_name;

      for_loop = Math.ceil(this.params.images.length / 9);
      this.params.sliced_images = [];
      for (let i = 0; i < for_loop; i++) {

        this.params.sliced_images[i] = this.params.images.slice(9 * i, 9 * (i + 1));

      }
      console.log('params.sliced_images', this.params.sliced_images);
    } else {
      this.$router.push({
        name: 'home'
      })
    }
    this.loading = false;
  },
  components: {
    layout,
    divider,
    ZoomIn:ZoomIn.default,
    X: X.default,
    ChevronIcon: ChevronRight.default
  },
  methods: {
    triggerLightbox(value) {
      this.srcNgaClicku= value;
      console.log('this.srcNgaClick',this.srcNgaClicku);
      this.showLightbox= true;
      this.$refs.esclistener.focus();
    },
    previous() {
      let index = this.params.images.findIndex(img => img.id === this.srcNgaClicku.id);

      if(index > 0 && index < this.params.images.length) {
        this.srcNgaClicku = this.params.images[index - 1];
      }
      this.$refs.esclistener.focus();

    },
    next() {
      let index = this.params.images.findIndex(img => img.id === this.srcNgaClicku.id);
      // this.tranformDivStyle =
      if(index >= 0 && index < this.params.images.length-1) {
        this.srcNgaClicku = this.params.images[index + 1];
      }
      this.$refs.esclistener.focus();

    },
    setImageFromDots(image){
      let index = this.params.images.findIndex(img => img.id === image.id);
      this.$refs.esclistener.focus();
      this.srcNgaClicku = image;
    }
  },
  computed: {
    ...mapState({
      hotel_name: state => state.hotel.name
    }),
    hotel() {
      return this.$store.state.hotel !== null;
    },
    property_code() {
      return this.$store.state.property_code;
    },
    web_config() {
      return !!this.hotel && this.$store.state.web_config;
    }
  },
  data: () => ({
    params: null,
    loading: false,
    srcNgaClicku: null,
    showLightbox:false,
  })
};
